import { SubItem } from "../SubItemTypes";

export const items: SubItem[] = [
  {
    heading: "Full-Stack Developer",
    terms: "04/2025 - 01/2026",
    sources: [
      {
        link: "https://cgsteam.io",
        name: "CGS-team",
      },
    ],
    stack: [
      "TypeScript",
      "React",
      "NestJS",
      "PostgreSQL",
      "Tanstack Query",
      "Tailwind CSS",
      "Prisma ORM",
      "Typeorm",
      "React Hook Form",
    ],
  },
  {
    heading: "Frontend Developer",
    terms: "02/2025 - 04/2025",
    sources: [
      {
        link: "https://www.winwin.travel",
        name: "WinWin Travel",
      },
    ],
    stack: [
      "TypeScript",
      "React",
      "Tanstack Query",
      "Tailwind CSS",
      "Zustand",
      "Storybook",
    ],
    links: [
      {
        link: "https://demo.winwin.travel",
        name: "App link",
      },
    ],
  },
];
